import React, { useEffect, useState } from 'react';
import app from './firebaseConfig'; // import your firebase configuration
import RinkMap from './RinkMap';
import { getFirestore, doc, getDoc } from 'firebase/firestore';

import { useTheme } from './hooks/useTheme';

function App() {
  const [rinks, setRinks] = useState([]);
  const [trails, setTrails] = useState([]);
  const [viewType, setViewType] = useState('rink'); // 'rink' or 'trail'
  const apiKey = 'AIzaSyCY7tnMWTt69m0AsmBNjpcJnwoMFylPJxI';
  const { theme, toggleTheme } = useTheme();

  useEffect(() => {
    // Function to fetch rinks data from Firestore
    const fetchRinks = async () => {
      const db = getFirestore(app);
      const docRef = doc(db, "aggregatedrinks", "data");
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        console.log("Rinks data:", docSnap.data());
        setRinks(docSnap.data().patinoire);
      }
    };

    // Function to fetch ski trails data from Firestore
    const fetchTrails = async () => {
      const db = getFirestore(app);
      const docRef = doc(db, "aggregatedskitrails", "data");
      try {
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          console.log("Trails data:", docSnap.data());
          const docData = docSnap.data();
          // Try to find the correct array field for trails
          if (docData.piste) {
            setTrails(docData.piste);
          } else if (docData.trails) {
            setTrails(docData.trails);
          } else if (docData.patinoire) {
            // Fallback if they reused the structure name
            setTrails(docData.patinoire);
          } else {
            // Fallback: use the first array value found in the object
            const firstArray = Object.values(docData).find(val => Array.isArray(val));
            if (firstArray) {
              setTrails(firstArray);
            } else {
              console.warn("No array found in ski trails document");
            }
          }
        }
      } catch (error) {
        console.error("Error fetching trails:", error);
      }
    };

    fetchRinks();
    fetchTrails();
  }, []);

  const currentData = viewType === 'trail' ? trails : rinks;

  return (
    <div className="App">
      <RinkMap
        rinks={currentData}
        apiKey={apiKey}
        theme={theme}
        toggleTheme={toggleTheme}
        viewType={viewType}
        onViewTypeChange={setViewType}
      />
    </div>
  );
}

export default App;
